/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two or three. A standard Venn diagram with proportional overlapping circles only works cleanly for up to three sets; four or more need a different chart.`)
};

const es_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos o tres. Un diagrama de Venn estándar con círculos superpuestos proporcionales solo funciona correctamente hasta tres conjuntos; cuatro o más necesitan un gráfico diferente.`)
};

const de_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei oder drei. Ein Standard-Venn-Diagramm mit proportional überlappenden Kreisen funktioniert nur für bis zu drei Mengen sauber; vier oder mehr benötigen ein anderes Diagramm.`)
};

const nl_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee of drie. Een standaard Venn-diagram met proportioneel overlappende cirkels werkt alleen goed voor maximaal drie sets; vier of meer hebben een andere grafiek nodig.`)
};

const fr_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux ou trois. Un diagramme de Venn standard avec des cercles proportionnels et chevauchants ne fonctionne proprement que jusqu'à trois ensembles ; quatre ou plus nécessitent un autre type de graphique.`)
};

const it_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due o tre. Un diagramma di Venn standard con cerchi sovrapposti proporzionali funziona bene solo fino a tre insiemi; quattro o più richiedono un grafico diverso.`)
};

const pt_br2_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois ou três. Um diagrama de Venn padrão com círculos proporcionais e sobrepostos só funciona bem com até três conjuntos; quatro ou mais precisam de um gráfico diferente.`)
};

const pt_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois ou três. Um diagrama de Venn padrão com círculos sobrepostos proporcionais só funciona bem até três conjuntos; quatro ou mais precisam de um gráfico diferente.`)
};

const ja_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つまたは3つです。円が比例して重なり合う標準的なベン図は、最大3集合まででないと綺麗に機能しません。4集合以上には別のチャートが必要です。`)
};

const zh_venn_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个或三个。带有成比例重叠圆圈的标准维恩图只能清晰地展示最多三个集合；四个或更多集合需要使用其他图表。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_a2", locale)
	if (locale === "en") return en_venn_faq_a2(inputs)
	if (locale === "es") return es_venn_faq_a2(inputs)
	if (locale === "de") return de_venn_faq_a2(inputs)
	if (locale === "nl") return nl_venn_faq_a2(inputs)
	if (locale === "fr") return fr_venn_faq_a2(inputs)
	if (locale === "it") return it_venn_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_a2(inputs)
	if (locale === "pt") return pt_venn_faq_a2(inputs)
	if (locale === "ja") return ja_venn_faq_a2(inputs)
	return zh_venn_faq_a2(inputs)
};